import { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { CondutorInterface as iData } from "../../interfaces";
import condutorService from "../../services/CondutorService";
import { JAlerta, MakeMessageError } from "../../components/Components";
import { rgx_numberOnly, rgx_numberOnlyPositivo } from "../../utils/utils";

const initial = {
    id: '',
    name: '',
    cpf: '',
    capacidade: '',
    placa: '',
    renavam: '',
    tara: '',
    active: true
}

const initialFieldsError = {
    cpf: [],
    name: [],
    capacidade: [],
    placa: [],
    renavam: [],
    tara: [],
}

export default function FormCondutor() {
    const navigate = useNavigate()
    const { id } = useParams<{ id: string }>();
    const [showError, setShowError] = useState(false);
    const [showMessageError, setShowMessageError] = useState('');
    const [errors, setErrors] = useState(initialFieldsError);
    const [data, setData] = useState<iData>(initial)

    useEffect(() => {

        if (id) {
            condutorService.get(id)
                .then(res => setData(res.data))
                .catch(err => navigate('/condutor'))
        }
    }, [id])

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (id) {
            try {
                await condutorService.update(id, data).then(() => {
                    navigate('/condutor')
                });

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 422) {
                        setErrors(error.response.data)
                    }
                    if (error.response.status === 403) {
                        setShowError(true)
                        setShowMessageError(error.response.data.message)
                    }
                    navigate(`/condutor/${id}`)
                }

            }

        } else {
            try {
                await condutorService.create(data).then(() => {
                    navigate('/condutor')
                });
            } catch (error: any) {

                if (error.response) {

                    if (error.response.status === 422) {
                        setErrors(error.response.data)
                    }
                    if (error.response.status === 403) {
                        setShowError(true)
                        setShowMessageError(error.response.data.message)
                    }
                    navigate("/condutor/create")
                }
            }

        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setErrors(prev => ({ ...prev, [name]: "" }));

        const transformers: Record<string, (val: string) => string> = {
            cpf: rgx_numberOnly,
            capacidade: rgx_numberOnlyPositivo,
            tara: rgx_numberOnlyPositivo
        };

        const newValue = transformers[name] ? transformers[name](value) : value;

        setData(prev => ({ ...prev, [name]: newValue }));
    };


    return (
        <div>

            <JAlerta showError={showError} close={setShowError} messageError={showMessageError} />

            <Form onSubmit={handleSubmit} noValidate >
                <Card className="card-success card-outline">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <div className="my-0">
                            <Button variant={id ? 'success' : 'primary'} type="submit">
                                <FontAwesomeIcon icon={faSave} /> {id ? 'Salvar' : 'Criar'}
                            </Button>
                            <Link to="/condutor" className="btn btn-secondary ms-1">
                                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                            </Link>
                        </div>
                        <div className="h5 py-0 m-0 text-muted">{id ? 'Editar' : 'Novo'} Condutor</div>
                    </Card.Header>

                    <Card.Body>
                        <Row className="g-2">
                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="cpf">
                                    <Form.Label>CPF</Form.Label>
                                    <Form.Control maxLength={11} name="cpf" value={data.cpf} autoFocus
                                        className={`${errors.cpf?.length > 0 ? "is-invalid" : ""}`}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="cpf" />
                                </Form.Group>
                            </Col>

                            <Col md>
                                <Form.Group className="mb-3" controlId="nome">
                                    <Form.Label>Nome do condutor</Form.Label>
                                    <Form.Control maxLength={50} name="name" value={data.name} type="text"
                                        className={`${errors.name?.length > 0 ? "is-invalid" : ""}`}
                                        onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="name" />

                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="placa">
                                    <Form.Label>Placa</Form.Label>
                                    <Form.Control maxLength={7} name="placa" value={data.placa}
                                        type="text" onChange={handleChange} />
                                    <MakeMessageError errors={errors} field="placa" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="renavam">
                                    <Form.Label>Renavam</Form.Label>
                                    <Form.Control maxLength={11} name="renavam" value={data.renavam}
                                        type="text" onChange={handleChange} />

                                    <MakeMessageError errors={errors} field="renavam" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="capacidade">
                                    <Form.Label>Capacidade(kg)</Form.Label>
                                    <Form.Control name="capacidade" value={data.capacidade} type="text"
                                        maxLength={6}
                                        onChange={handleChange} />

                                    <MakeMessageError errors={errors} field="capacidade" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="tara">
                                    <Form.Label>Tara(kg)</Form.Label>
                                    <Form.Control name="tara" value={data.tara} type="text" maxLength={6}
                                        onChange={handleChange} />

                                    <MakeMessageError errors={errors} field="tara" />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="active">
                                    <Form.Switch type="switch" name="active" label="Ativo?" checked={data.active}
                                        onChange={(e) => setData({ ...data, active: e.target.checked })} />
                                </Form.Group>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </Form>
        </div>
    );
}
